import { useCallback, useState } from 'react';
import { useAppStore } from 'store/hooks';
import { selectIsWalkthroughInactive } from 'features/feed/selectors';
import { selectIsPayFeedSpotlightActive } from 'reducers/selectors/walkthrough';
// only collect layouts while something that needs them is running
const shouldSkipCollecting = (state) => selectIsWalkthroughInactive(state) && !selectIsPayFeedSpotlightActive(state);
const useWalkthroughLayout = () => {
    const [itemPositions, setItemPositions] = useState({});
    const store = useAppStore();
    const onLayout = useCallback((item, event) => {
        if (shouldSkipCollecting(store.getState()))
            return;
        const layout = { ...event.nativeEvent?.layout };
        setItemPositions((s) => ({
            ...s,
            [item]: layout,
        }));
    }, []);
    const [scrollHeight, setScrollHeight] = useState(0);
    const onContentSizeChange = useCallback((_, height) => {
        if (shouldSkipCollecting(store.getState()))
            return;
        setScrollHeight(height);
    }, []);
    const [scrollLayoutHeight, setScrollLayoutHeight] = useState(0);
    const onScrollLayout = useCallback((event) => {
        if (shouldSkipCollecting(store.getState()))
            return;
        setScrollLayoutHeight(event.nativeEvent.layout.height);
    }, []);
    return {
        itemPositions,
        scrollHeight,
        scrollLayoutHeight,
        onLayout,
        onContentSizeChange,
        onScrollLayout,
    };
};
export default useWalkthroughLayout;
